import type { BookingEventWaveDetail } from '@/types';
import type { ReactNode } from 'react';

import { Badge } from '@/components/ui/badge';

import { cn } from '@/lib/utils';

type WaveTileProps = {
  wave: BookingEventWaveDetail;
  period: string;
  isSelected: boolean;
  isDisabled?: boolean;
  onWaveSelect: () => void;
  children?: ReactNode;
};

export const WaveTile = (props: WaveTileProps) => {
  const { wave, period, isSelected, isDisabled, onWaveSelect, children } =
    props;

  return (
    <button
      type="button"
      onClick={onWaveSelect}
      disabled={isDisabled}
      aria-pressed={isSelected}
      className={cn(
        'text-foreground grid gap-0.5 rounded-md border px-3 py-2 text-left text-sm',
        isSelected && 'border-primary bg-muted',
        isDisabled && 'cursor-not-allowed opacity-60',
      )}
    >
      <span className="flex items-center gap-2 font-medium">
        {wave.name}
        <Badge
          size="sm"
          variant="secondary"
        >
          {`${wave.taken_spots}/${wave.capacity}`}
        </Badge>
      </span>
      <span className="text-muted-foreground text-xs">
        {`${period} · ${wave.service.name}`}
      </span>
      {children}
    </button>
  );
};
